var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-8 max-w-xl mt-6"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.page)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.page)}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }